
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionHerramienta = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionHerramientaTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionHerramientaTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionHerramienta;